import { hzExhibitionLogin, hzAudienceLogin, hzExhibitionIndex, hzAudienceIndex, messageUrl } from './common';
import config from '../config';
import { Message } from 'element-ui';
import VueI18n from 'vue-i18n';

// 跳转观众登录界面
export function audienceLogin() {
  return config.hzAudienceLogin;
}
export function login(val, id) {
  const i18n = new VueI18n({ 
    locale: localStorage.getItem('lang') || 'zh',
    messages: {
      zh: require('../src/assets/i18n/zh'),
      en: require('../src/assets/i18n/en'),
    },
    silentTranslationWarn: true,
  });
  const isToken = localStorage.getItem('viewToken'); //观众
  const zsToken = localStorage.getItem('token'); //展商
  console.log(val)
  //如果两个token都存在的情况下，需要可以进入个人中心，进行注销
  if((isToken != '' && isToken !=null) && (zsToken !='' && zsToken !=null)){
    if(val == 2){
      //展商
      window.location.href = hzExhibitionIndex();
    }
    if(val == 1){
      window.location.href = hzAudienceIndex();
    }
  }
  if (val == 2) {
    //展商
    if (isToken) {
      Message({
        showClose: true,
        message: i18n.t('message.isLimit'),
        type: 'error',
      });
      return;
    } else if (zsToken) {
      window.location.href = hzExhibitionIndex();
    } else if (!zsToken) {
      window.location.href = hzExhibitionLogin();
    }
  } else if (val == 1) {
    //观众
    if (zsToken) {
      Message({
        showClose: true,
        message: i18n.t('message.isLimit'),
        type: 'error',
      });
      return;
    } else if (isToken) {
      if (id) {
        window.location.href = messageUrl() + '?receiveUserId=' + id;
      } else {
        window.location.href = hzAudienceIndex();
      }
    } else if (!isToken) {
      if (id) {
        window.location.href = hzAudienceLogin() + '?redirectUrl=' + encodeURIComponent(messageUrl() + '?receiveUserId=' + id);
      } else {
        window.location.href = hzAudienceLogin();
      }
    }
  } else if (val == 3) {
    if (zsToken) {
      Message({
        showClose: true,
        message: i18n.t('message.audienceAccount'),
        type: 'error',
      });
      return;
    } else {
      Message({
        showClose: true,
        message: i18n.t('message.audienceAccount'),
        type: 'error',
      });
      setTimeout(() => {
        window.location.href = hzAudienceLogin();
      }, 1000);
    }
  }
}
